export default __webpack_public_path__ + "static/media/content_creator.dd224b85.svg";